import { Box, ListItem, Menu, useTheme } from '@mui/material';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  ArrowRight,
  ListItemButtonMenu,
  ListItemIconMenu,
  ListItemTextMenu,
  MenuItems,
} from '../Layouts/StyledComponentsMenu';

export const MenuItemComponent = ({
  open,
  icon: Icon,
  label,
  handleNavigate,
  activeItem,
  setActiveItem,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const theme = useTheme();

  const isActive = activeItem?.toLowerCase() === label.toLowerCase();

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleItemClick = label => {
    const normalized = label.toLowerCase();
    if (activeItem?.toLowerCase() !== normalized) {
      setActiveItem(normalized);
    }
    handleNavigate(normalized);
    setAnchorEl(null);
  };

  return (
    <ListItem disablePadding>
      <ListItemButtonMenu
        open={open}
        onClick={event => {
          open ? handleItemClick(label) : setAnchorEl(event.currentTarget);
        }}
        sx={{
          mt: '6px',
          backgroundColor: open
            ? isActive
              ? 'rgba(231, 243, 255, 0.25)'
              : 'transparent'
            : isActive
              ? theme.palette.white.main
              : 'transparent',

          color: open
            ? isActive
              ? theme.palette.white.main
              : theme.palette.white.main
            : isActive
              ? theme.palette.primary.dark
              : theme.palette.white.main,

          '&:hover': open
            ? isActive
              ? {}
              : { backgroundColor: theme.palette.primary.main }
            : {
                backgroundColor: isActive ? theme.palette.white.main : theme.palette.primary.main,
              },
          boxShadow: isActive ? 2 : 0,
        }}>
        <ListItemIconMenu
          mr={open ? 9 : '0px'}
          sx={{
            color: open
              ? isActive
                ? theme.palette.white.main
                : theme.palette.white.main
              : isActive
                ? theme.palette.primary.dark
                : theme.palette.white.main,
          }}>
          <Icon />
        </ListItemIconMenu>
        {open ? (
          <ListItemTextMenu open={open} primary={label} />
        ) : (
          <ListItemIconMenu
            sx={{
              color: isActive ? theme.palette.primary.dark : theme.palette.white.main,
            }}>
            <ArrowRight
              sx={{
                color: isActive ? theme.palette.primary.dark : theme.palette.white.main,
              }}
            />
          </ListItemIconMenu>
        )}
      </ListItemButtonMenu>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
        transformOrigin={{ vertical: 'center', horizontal: 'left' }}
        MenuListProps={{ 'aria-labelledby': 'basic-button' }}
        sx={{ borderRadius: '8px', marginLeft: '36px' }}>
        <Box>
          <MenuItems
            onClick={() => {
              handleItemClick(label);
              handleClose();
            }}>
            {label}
          </MenuItems>
        </Box>
      </Menu>
    </ListItem>
  );
};
